module.exports = __webpack_public_path__ + "img/st.9fb0ea9d.svg";